import { type ReactNode } from 'react';
import { transChoice } from '@lingoda/i18n';
import { Stack, Typography } from '@lingoda/ui';
import { ClockIcon, UsersThreeIcon } from '@lingoda/ui/icons/lingodaIcons';

interface ActiveChallengeWidgetHeaderProps {
    subtitle: string;
    title: string;
    iconUrl: string | undefined;
    statusText: string;
    participants?: number;
}

export const ActiveChallengeWidgetHeader = (props: ActiveChallengeWidgetHeaderProps) => {
    return (
        <Stack direction="row" spacing={2} sx={{ width: '100%', justifyContent: 'space-between' }}>
            <Stack spacing={1}>
                <Typography variant="overline" sx={({ colors }) => ({ color: colors.text.subtle })}>
                    {props.subtitle}
                </Typography>
                <Typography variant="h3">{props.title}</Typography>
                <Stack spacing={1} sx={({ colors }) => ({ color: colors.text.subtle })}>
                    <InfoRow icon={<ClockIcon size={16} />}>{props.statusText}</InfoRow>
                    {props.participants !== undefined && (
                        <InfoRow icon={<UsersThreeIcon size={16} />}>
                            {transChoice(
                                'participants',
                                props.participants,
                                { participants: props.participants },
                                'student-challenges',
                            )}
                        </InfoRow>
                    )}
                </Stack>
            </Stack>
            <img src={props.iconUrl} alt={props.title} width={64} height={64} />
        </Stack>
    );
};

interface InfoRowProps {
    icon: ReactNode;
    children: ReactNode;
}

const InfoRow = (props: InfoRowProps) => {
    return (
        <Stack spacing={0.5} direction="row">
            {props.icon}
            <Typography variant="body3">{props.children}</Typography>
        </Stack>
    );
};
